import React from 'react'
import {Marker, Popup} from 'react-leaflet'
import {icon} from 'leaflet'

const serviceTypeToIconPath = (serviceType) => {
  switch(serviceType){
    case 'restaurant': return "/images/marker/marker-restaurant.png"
    case 'supermarket': return "/images/marker/marker-grocery.png"
    case 'hospital':  return "/images/marker/marker-hospital.png"
    case 'transport': return "/images/marker/marker-bus.png"
    case 'parking': return "/images/marker/marker-parking.png"
    case 'mall': return "/images/marker/marker-shopping.png"
  }
}

const serviceIcon = serviceType => icon({
  iconUrl:serviceTypeToIconPath(serviceType),
  iconSize:[57,61],
  iconAnchor: [29,27]
})

const ServiceMarker = ({address, coordinates, type, name, ...passThrought}) => {
  return <Marker position={coordinates} icon={serviceIcon(type)} zIndexOffset={1} {...passThrought}>
    <Popup>
      <span>
        <b>{name && name != 'null' ? name : null}</b>
        <div>{address && address != 'null' ? address : null}</div>
      </span>
    </Popup>
  </Marker>
}

export default ServiceMarker



/** WEBPACK FOOTER **
 ** ./app/components/ServiceMarker.jsx
 **/